import React, { FC, useEffect, useState } from 'react'
import { Header as GenericHeader } from '@ampdx/component-library/dist/components/'
import { HeaderProps } from './Header.types'
import { APIENDPOINT, getCWPEnvironmentForURL } from '../../../common/utils/common-utils'
import { useFetch } from '../../../common/utils/hooks'

export const Header: FC<HeaderProps> = props => {
  const { menuName, dropdownOptions, mobileButton, desktopImage } = props.content
  const [windowWidth, setWindowWidth] = useState(0)
  useEffect(() => {
    const handleWindowSizeChange = () => {
      setWindowWidth(window.innerWidth)
    }
    window.addEventListener('resize', handleWindowSizeChange)
    setWindowWidth(window.innerWidth)
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [])
  const env = getCWPEnvironmentForURL(window.location.href)
  const careersMenuUrl = `${APIENDPOINT(env).menuBaseWithParams}${menuName}`
  const careersMenu = useFetch(windowWidth < 1025 ? careersMenuUrl : '')
  return (
    <GenericHeader
      headerDocument={{ desktopImage }}
      mainMenu={careersMenu}
      dropdownOptions={dropdownOptions}
      mobileButton={mobileButton}
      backgroundColor={'u-bgColorWhite'}
      textColor={'u-textColorActionBlue'}
      menuIconColor={'u-bgColorActionBlue'}
    />
  )
}
